import React from 'react';
import { Box } from '@mui/material';

/**
 * Wraps form page content in a scrollable area so each form scrolls independently.
 * Use as the root wrapper for form pages (e.g. AccountsFormPage, CommoditiesFormPage).
 */
export default function FormPageScroll({ children, ...boxProps }) {
    return (
        <Box
            sx={{
                flex: 1,
                minHeight: 0,
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                ...boxProps?.sx,
            }}
            {...boxProps}
        >
            {children}
        </Box>
    );
}
